import * as React from 'react';
import { FailedPaymentRequest, PaymentsState } from '../payments/Types';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { validateCreditCardNumber } from '../util/Validation';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { M3_LOGO } from '../navigation/Constants';
import { renderCreditCardIcon, parseCreditCardType } from '../creditcard/CreditCardIconHelper';
import { CreditCardType } from '../payments/Types';
import { NONE, CREDIT_CARD_LENGTH } from '../payments/Constants';

type Props = {
  readonly paymentsState: PaymentsState
  readonly retryFailedPayment: (failedPaymentRequest: FailedPaymentRequest) => Promise<Response>
};

type States = {
  readonly paymentCode: string
  readonly email: string
  readonly cardHolderName: string
  readonly cardNumber: string
  readonly expiryMonth: string
  readonly expiryYear: string
  readonly cvc: string
  readonly loading: boolean
  readonly done: boolean
  readonly msg: string
  readonly creditcardType: CreditCardType
};

class PosSaleNoLoginComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
      paymentCode: '',
      email: '',
      cardHolderName: '',
      cardNumber: '',
      expiryMonth: '',
      expiryYear: '',
      cvc: '',
      loading: false,
      msg: '',
      done: false,
      creditcardType: NONE
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.paymentsState !== nextProps.paymentsState) {
      this.setState(
        {
          loading: false,
          done: nextProps.paymentsState.statusCode === 200, 
          msg: nextProps.paymentsState.statusCode === 200 ?
            '' :
            'Transaction Failed. Please contact cs@mimosa.solutions or 1-833-597-5554'
          }
      );
    }
  }
 
  render() {
    return(
      <div
        style={{backgroundColor: '#43464e', height: '100vh'}}
      >
        <div
          className="row justify-content-center align-items-center"
          style={{height: '100vh'}}
        >
          <div
            className="col-5 75vh"
          >
            <div className="row justify-content-center mt3 mb3">
              <div className="col-6">
                <img
                  id="sidebar_m3_logo"
                  src={M3_LOGO}
                  alt="M3_Logo"
                  title="M3_Logo"
                />
              </div>
            </div>
            {this.state.done ?
              this.renderResultText() :
              this.renderPaymentSection()
            }
          </div>
        </div>
      </div>
    );
  }

  private renderResultText = (): JSX.Element => {
    return(
      <div className="row justify-content-center mt3 mb3">
        <div className="col-12">
          <h1
            style={{
              color: 'white',
              textAlign: 'center'
            }}
          >
            Thank you for your cooperation. A receipt for payment has been sent to your email.
          </h1>
        </div>
      </div>
    );
  }

  private renderPaymentSection = (): JSX.Element => {
    return(
      <Paper zDepth={3}>
        <div className="row pa3">
          <div className="col-12">
            <TextField
              floatingLabelText="Payment Code (Numbers Only)"
              value={this.state.paymentCode}
              onChange={this.handlePaymentCodeChange}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3">
          <div className="col-12">
            <TextField
              floatingLabelText="Email"
              value={this.state.email}
              onChange={this.handleEmailChange}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3">
          <div className="col-12">
            <TextField
              floatingLabelText="Card Holder Name"
              value={this.state.cardHolderName}
              onChange={this.handleCardHolderNameChange}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3">
          <div className="col-12">
            {renderCreditCardIcon(this.state.creditcardType)}
            <TextField
              floatingLabelText="Card Number"
              value={this.state.cardNumber}
              onChange={this.handleCardNumberChange}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3">
          <div className="col-4">
            <TextField
              floatingLabelText="Expiry Month (MM)"
              value={this.state.expiryMonth}
              onChange={this.handleExpiryMonthChange}
              fullWidth={true}
            />
          </div>
          <div className="col-4">
            <TextField
              floatingLabelText="Expiry Year (YY)"
              value={this.state.expiryYear}
              onChange={this.handleExpiryYearChange}
              fullWidth={true}
            />
          </div>
          <div className="col-4">
            <TextField
              floatingLabelText="CVC"
              value={this.state.cvc}
              onChange={this.handleCvcChange}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3 justify-content-end">
          <div className="col-auto">
            {
              this.state.loading ?
                <RefreshIndicator
                  size={40}
                  left={10}
                  top={0}
                  status="loading"
                  style={{
                    display: 'inline-block',
                    position: 'relative',
                  }}
                /> :
                <RaisedButton
                  label="SUBMIT"
                  primary={true} 
                  disabled={!this.allFieldsFilled()}
                  onClick={this.onSubmitClick}
                />
            }
          </div>
        </div>
        <div className="row pa3 justify-content-end">
          <div className="col-12 red">
            {this.state.msg}
          </div>
        </div>
      </Paper>
    );
  }

  private onSubmitClick = (): void =>
    this.setState(
      {loading: true},
      () => this.props.retryFailedPayment({
        paymentCode: parseInt(this.state.paymentCode, 10),
        email: this.state.email,
        cardNumber: this.state.cardNumber,
        cardHolderName: this.state.cardHolderName,
        cvc: this.state.cvc,
        expiryMonth: this.state.expiryMonth,
        expiryYear: this.state.expiryYear,
        country: 'CA'
      })
    )

  private allFieldsFilled = (): boolean => {
    return this.state.paymentCode !== '' && validator.isNumeric(this.state.paymentCode) && this.state.email !== '' &&
      this.state.cardNumber !== '' && this.state.cardHolderName !== '' && this.state.cvc !== ''
      && this.state.expiryMonth !== '' && this.state.expiryYear !== '';
  }

  private handlePaymentCodeChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({paymentCode: newValue})
  
  private handleEmailChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({email: newValue})
  
  private handleCardHolderNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({cardHolderName: newValue})
  
  private handleCardNumberChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      cardNumber: newValue,
      creditcardType: newValue.length === CREDIT_CARD_LENGTH && validateCreditCardNumber(newValue) ?
        parseCreditCardType(newValue) :
        NONE
    })
  
  private handleExpiryMonthChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({expiryMonth: newValue})

  private handleExpiryYearChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({expiryYear: newValue})

  private handleCvcChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({cvc: newValue})
}

export default PosSaleNoLoginComponent;



// WEBPACK FOOTER //
// ./src/pos/PosSaleNoLoginComponent.tsx